<template>
  <div
    class="contact-form-landing-section"
    :style="{ backgroundImage: `url(${exCover.url})` }"
  >
    <div class="contact-form-container">
      <!-- Left Side - Content -->
      <div class="form-content">
        <!-- Branding -->
        <div class="branding">
          <div class="logo">
            <LadNavigationLogo />
          </div>
        </div>

        <!-- Headline -->
        <h1 class="headline">{{
          $t(`${base}.headline`, { country: exExperience.country.name })
        }}</h1>

        <!-- Description -->
        <p class="description">{{ $t(`${base}.description`) }}</p>

        <!-- Features List -->
        <ul class="features-list">
          <li class="feature-item">
            <i class="el-icon-circle-check feature-icon"></i>
            <span>{{ $t(`${base}.features.one`) }}</span>
          </li>
          <li class="feature-item">
            <i class="el-icon-circle-check feature-icon"></i>
            <span>{{ $t(`${base}.features.two`) }}</span>
          </li>
          <li class="feature-item">
            <i class="el-icon-circle-check feature-icon"></i>
            <span>{{ $t(`${base}.features.three`) }}</span>
          </li>
        </ul>
      </div>

      <!-- Right Side - Form -->
      <div class="form-fields">
        <LadZohoFormLead @submitted="handleSubmitted">
          <LadFacebookWidget
            v-if="submitted"
            slot="sent"
            :group-id="exExperience.facebook_group_id"
          />
        </LadZohoFormLead>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ContactForm',
  components: {
    LadNavigationLogo: () =>
      import(
        /* webpackChunkName: "lad-navi-logo" */ '@/components/layout/Navigation/components/Logo'
      ),
    LadZohoFormLead: () =>
      import(
        /* webpackChunkName: "lad-zoho-form--lead" */ '@/components/zoho-form/lead'
      ),
  },
  data() {
    return {
      base: 'landing.contact',
      submitted: false,
    }
  },
  computed: {
    ...mapState('experience', {
      exExperience: (state) => ({
        country: state.experience.country,
        facebook_group_id: state.experience.facebook_group_id,
      }),
      exCover: 'cover',
    }),
  },
  methods: {
    handleSubmitted() {
      this.submitted = true
    },
  },
}
</script>

<style lang="scss">
.contact-form-landing-section {
  object-fit: cover;
  background-position: center;
  padding: 80px 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  .contact-form-container {
    background: rgba(255, 255, 255, 0.8);
    width: 100%;
    border-radius: 8px;
    max-width: 1200px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
      flex-direction: row;
    }
  }

  .form-content {
    padding: 40px 30px;
    flex: 1;

    @media (min-width: 768px) {
      flex: 1.2;
      padding: 50px 40px;
    }
  }

  .branding {
    margin-bottom: 15px;
  }

  .logo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .logo-local {
    font-size: 32px;
    font-weight: 800;
    color: #0a960c;
    letter-spacing: -1px;

    &::before {
      content: '🌿';
      margin-right: 8px;
      font-size: 28px;
    }
  }

  .logo-adventures {
    font-size: 16px;
    font-weight: 400;
    color: #4a9c4a;
    margin-top: -5px;
  }

  .headline {
    font-size: 28px;
    font-weight: 700;
    color: #221f20;
    line-height: 1.2;
    margin: 0 0 8px 0;

    @media (min-width: 768px) {
      font-size: 32px;
    }
  }

  .description {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6;
    color: #221f20;
    margin: 0 0 8px 0;

    @media (min-width: 768px) {
      font-size: 20px;
    }
  }

  .features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .feature-item {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #221f20;
    line-height: 1.4;
    font-weight: 700;
    margin: 0;

    &:not(:last-child) {
      margin: 0 0 8px;
    }

    @media (min-width: 768px) {
      font-size: 20px;
    }
  }

  .feature-icon {
    color: #0a960c;
    font-weight: bold;
    font-size: 18px;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .form-fields {
    padding: 40px 30px;
    flex: 1;

    @media (min-width: 768px) {
      padding: 50px 40px;
    }
  }

  .lad-navigation--logo {
    a {
      float: unset;

      .sprite-icons {
        max-width: 150px;
        max-height: 50px;
      }
    }
  }

  .lad-zoho {
    // background-color: transparent !important;

    &--header {
      display: none;
    }
  }
}
</style>
